var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('the-header-login'),_c('v-main',{staticClass:"login-page"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('the-footer'),_c('the-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }